import * as React from 'react';
import { useState, useEffect, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from "axios"
import FeedSettings from './DataInputPageComponents/dataFeedSetting.js'
// import APIConnecting from './DataInputPageComponents/apiConnecting.js'
import emailjs from "emailjs-com";
import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { getFirestore, addDoc, collection, onSnapshot, query, where } from 'firebase/firestore'

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
const storage = getStorage(firebaseApp);
const firestore = getFirestore(firebaseApp);

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function DataInputPage() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [filename, setFilename] = useState([])
    const [source, setSource] = useState({"name": ""})

    const [tmpheader, setTmpheader] = useState([])
    const [header, setHeader] = useState([])
    const [tmpdata, setTmpdata] = useState([])
    const [data, setData] = useState([])

    function formatDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    /* Storage upload functions */
    function uploadFiles(file, name, method) {
            console.log(file)
            setFilename(name)
            setSource({"name": name, "method": method})
            const reader = new FileReader()
      
            reader.onload = function (e) {
              const text = e.target.result;
              const Data = csvToArray(text);
              setTmpdata(Data)
            };
      
            reader.readAsText(file)
            
            const userRef = ref(storage, user_email+'/'+name)
            uploadBytes(userRef, file).then((snapshot) => {
                console.log("Uploaded file!")
                alert("Upload successfully!")

                const email = user_email
                const content = "Uploaded a file : " + name
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
    }

    function csvToArray(str, delimiter = ",") {
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
        if (headers.length > 10) {
          const res = headers.slice(0, 10)
          setTmpheader(res)
        } else {
          setTmpheader(headers)
        }
        const rows = str.slice(str.indexOf("\n") + 1).split("\n");
        const arr = rows.map(function (row) {
          const values = row.split(delimiter);
          const el = headers.reduce(function (object, header, index) {
            object[header] = values[index];
            return object;
          }, {});
          return el;
        });
  
        if (arr.length > 10) {
          return arr.slice(0, 10)
        } else {
          return arr
        }
        return 
    }

    /* Drag and Drop area */
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.map((file) => {
            uploadFiles(file, file.name, "File uploaded")
        });
    }, []);

    const { getRootProps, getInputProps, acceptedFiles, isDragActive } = useDropzone({ onDrop, accept: {'text/csv': ['.csv']} })

    /* Loading function for reading data */
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef();

    React.useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
    }, []);

    const handleButtonClick = () => {
        if (!loading) {
          setSuccess(false);
          setData();
          setHeader();
          setLoading(true);
          timer.current = window.setTimeout(() => {
            setSuccess(true);
            setLoading(false);
            setData(tmpdata);
            setHeader(tmpheader);
          }, 2000);
        }
    };

    const [openD, setOpenD] = React.useState(false);

    const [link, setLink] = useState([])
    const [server, setServer] = useState([])
    const [databaseName, setDatabaseName] = useState([])
    const [userName, setUserName] = useState([])
    const [password, setPassword] = useState([])

    const [database, setDatabase] = useState([])
    const [current, setCurrent] = useState([])
    const [status, setStatus] = useState([])
    const [api, setApi] = useState([])
    const [apiName, setApiName] = useState([])

    useEffect(() => {
        const databaseQuery = query(
        collection(firestore, 'userDatabase'),
        where('user_email', '==', user_email)
        );
        const unsubscribe = onSnapshot(databaseQuery, snapshot => {
            setDatabase(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
            unsubscribe()
        }
    }, [])

    useEffect(() => {
        const statusQuery = query(
        collection(firestore, 'userDatabase'),
        where('user_email', '==', user_email),
        where('databaseName', '==', current)
        );
        const unsubscribe = onSnapshot(statusQuery, snapshot => {
            setStatus(snapshot.docs.map(doc => doc.data().status ))
            setApi(snapshot.docs.map(doc => doc.data().apiAddress ))
            setApiName(snapshot.docs.map(doc => doc.data().databaseName ))
        })

        return () => {
            unsubscribe()
        }
    }, [current])

    const handleClose = () => {
        setOpenD(false);
        setLink([])
        setServer([])
    };
    
    const handleClickOpen = () => {
        setOpenD(true);
    };

    function handleSubmit(e) {
        e.preventDefault()
        if (link == "" || server == "" || databaseName == "" || userName == "" || password == "") {
            alert("Please fill in all fields below!")
            return 
        }

        const CollectionRef = collection(firestore, 'userDatabase')
        const status = "Not connected"
        const apiAddress = ""
        addDoc(CollectionRef, {user_email, link, server, databaseName, userName, password, status, apiAddress})
        .then(response => {
            console.log(response.id)
            alert("Have sent request! Please wait for us to build connection to your data. Check it later.")
            setOpenD(false)
            emailjs.send("teamService","template_cqyfsfh",{
                subject: "New Request of API Connection",
                name: server,
                email: user_email,
                message: link,
            }, "r87tnpnYE2FXwhAzx");

            const email = user_email
            const content = "Requested an API connection: " + databaseName
            const date = formatDate()
            const time = new Date()
            addDoc(collection(firestore, 'alerts'), {email, content, date, time})
        })
        .catch(error => {
            console.log(error.message)
            alert(error.message)
            setOpenD(false)
        })
    }

    function handleConnectDatabase() {
        axios
            .post(
                api[0],
                {
                    email: user_email
                }
            )
            .then((response) => {
                const res = exportJSONToCSV(response.data)
                uploadFiles(res, apiName+".csv", "API connection")
            }).catch((error) => {
                console.log(error.message)
                alert(error.message)
            });
    }

    function exportJSONToCSV(objArray) {
        var arr = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        var str =
          `${Object.keys(arr[0])
            .map((value) => `${value}`)
            .join(',')}` + '\r\n';
        var csvContent = arr.reduce((st, next) => {
          st +=
            `${Object.values(next)
              .map((value) => `${value}`)
              .join(',')}` + '\r\n';
          return st;
        }, str);
        var blob = new Blob([csvContent]);
        return blob
        // var element = document.createElement('a');
        // element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
        // element.target = '_blank';
        // element.download = 'export.csv';
        // element.click();
      }

    return (
        <Box  sx={{ display: 'flex', height: '100%' }}>
            {/* Side bar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                        {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>

                <Divider />

                {/* Navigations to different pages */}
                <List component="nav">
                    <ListItemButton>
                        <ButtonBase href="/Dashboard/Engineering/Input" fullWidth>
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Input" />
                        </ButtonBase>
                    </ListItemButton>

                    <ListItemButton>
                        <ButtonBase href="/Dashboard/Engineering" fullWidth>
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Feeds" />
                        </ButtonBase>
                    </ListItemButton>

                    <ListItemButton>
                        <ButtonBase href="/Dashboard/Engineering/Processing" fullWidth>
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Processing" />
                        </ButtonBase>
                    </ListItemButton>

                    <ListItemButton>
                        <ButtonBase href="/Dashboard/Engineering/Augmentation" fullWidth>
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Augmentation" />
                        </ButtonBase>
                    </ListItemButton>
                </List>
            </Drawer>

            <Box sx={{ width: '90%' }}>
                {/* Title */}
                <Typography
                    component="h1"
                    variant="subtitle1"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                    >
                    Ambient / Data Engineering / Data Input
                </Typography>
                <Typography
                    component="h1"
                    variant="h4"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                    >
                    Data Input
                </Typography>

                <Typography
                        component="h1"
                        variant="h7"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 4, ml: 8 }}
                        >
                        Please upload your data in one of these ways: 
                    </Typography>

                <Box sx={{ mt: 2, display: 'flex' }}>
                    <Box>
                        <Box sx={{ border: 2, borderStyle: 'dotted', ml: 8, mt: 1 }}>
                            <Box {...getRootProps({})} display="flex" justifyContent="center" alignItems="center" sx={{ minWidth: 600, minHeight: 300 }} >
                                <input {...getInputProps()} onDrop={onDrop}/>
                                {isDragActive ? (
                                    <Typography variant="h5">Drop (only .csv file)</Typography>
                                ) : (
                                    <Typography variant="h5">Drag file and drop here / Click to upload</Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ ml: 8, mr: 5, border: 1, borderColor: '#B0C4DE' }} />

                    <Box>
                        <Button variant="contained" color='primary' sx={{ mt: 1 }} onClick={handleClickOpen}>Connect your own DB / API</Button>
                        <Dialog open={openD} onClose={handleClose}>
                            <DialogTitle>External Connection</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Please provide the information for us to connect to get the data.
                                </DialogContentText>

                                <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                    <TextField autoFocus margin="dense" id="server" label="Type of database (e.g. GCP SQL / Own server, Postgre)" fullWidth variant="standard" onChange={(e) => {setServer(e.target.value)}} />
                                    <TextField autoFocus margin="dense" id="link" label="Link (e.g. endpoint ID number / URL )" fullWidth variant="standard" onChange={(e) => {setLink(e.target.value)}} />
                                    <TextField autoFocus margin="dense" id="databaseName" label="Database name" fullWidth variant="standard" onChange={(e) => {setDatabaseName(e.target.value)}} />
                                    <TextField autoFocus margin="dense" id="userName" label="Username of database account" fullWidth variant="standard" onChange={(e) => {setUserName(e.target.value)}} />
                                    <TextField autoFocus margin="dense" id="password" label="Password of database user" fullWidth variant="standard" onChange={(e) => {setPassword(e.target.value)}} />
                                </FormControl>
                            </DialogContent>

                            <DialogActions>
                                <Button onClick={handleClose}>Cancel</Button>
                                <Button onClick={handleSubmit}>Submit</Button>
                            </DialogActions>
                        </Dialog>

                        <Box sx={{ mt: 4 }}>
                            <Typography variant="h7">Connection you request:</Typography>
                            <FormControl variant= "standard" sx={{ mt: -1, ml: 1 }}>
                                <Select native defaultValue="" id="grouped-native-select" label="Select Connection" disableUnderline onChange={(e) => setCurrent(e.target.value)}
                                    theme={theme}
                                    sx={{
                                        borderRadius: 25,
                                        backgroundColor: theme.palette.background.default,
                                        padding: "6px 15px",
                                    }}
                                >
                                    <option value="">Select Connection</option>
                                    {database?.map((row) => (
                                    <option value={row.data.databaseName}>{row.data.databaseName}</option>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{ mt: 4 }}>
                            {current? (
                                <Typography variant="h7" color="#228B22">Status: {status[0]}</Typography>
                            ):(
                                <div></div>
                            )}
                            {status[0] == "Connected" ? (
                                <Button sx={{ ml : 5, mt: -0.3 }} onClick={handleConnectDatabase}>
                                    import data
                                </Button>
                            ):(
                                <div></div>
                            )}
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ mt: 4, ml: 8, display: 'flex' }}>
                    <Typography variant="h7" sx={{ mt: 1, mr: 1 }} >Can check your data:</Typography>
                    <Button
                        variant="contained" disabled={loading} onClick={handleButtonClick}
                    >
                        Read Data
                    </Button>

                    {filename? (
                        <Typography variant="h7" sx={{ mt: 1, ml: 3}}>Your current file: {filename}</Typography>
                    ) : (
                        <Typography variant="h7" sx={{ mt: 1, ml: 3}}>Your current file:</Typography>
                    )}

                    <Box sx={{ minWidth: 200 }} />

                    <FeedSettings source={source}/>

                </Box>

                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                        color: green[500],
                        marginLeft: '30px',
                        }}
                    />
                )}

                {/* Hidden table */}
                <Box>
                <TableContainer component={Paper} sx={{ mt: 2, ml: 8 }}>
                    <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="a dense table"
                    >
                    <TableHead>
                        <TableRow>
                        {header?.map((column) => (
                            <TableCell align="right">{column}</TableCell>
                        ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.map((row) => (
                        <TableRow
                            key={Object.values(row)[0]}
                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                            {Object.values(row)[0]}
                            </TableCell>
                            <TableCell align="right">{Object.values(row)[1]}</TableCell>
                            <TableCell align="right">{Object.values(row)[2]}</TableCell>
                            <TableCell align="right">{Object.values(row)[3]}</TableCell>
                            <TableCell align="right">{Object.values(row)[4]}</TableCell>
                            <TableCell align="right">{Object.values(row)[5]}</TableCell>
                            <TableCell align="right">{Object.values(row)[6]}</TableCell>
                            <TableCell align="right">{Object.values(row)[7]}</TableCell>
                            <TableCell align="right">{Object.values(row)[8]}</TableCell>
                            <TableCell align="right">{Object.values(row)[9]}</TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                    </Table>
                </TableContainer>
                </Box>
            </Box>
        </Box>
    );
}